import React, { useCallback, useRef } from 'react'
import styled from 'styled-components'
import 'react-calendar/dist/Calendar.css'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import DateTimePicker from 'react-datetime-picker/dist/entry.nostyle'
import { parseISO, isValid, set } from 'date-fns'
import { IconCalendar } from '../../iconography/Icons/Icons'
import { FormField } from '../../form/FormField/FormField'
import './styles.css'

const Wrapper = styled.div`
  position: relative;
  outline: none;
  max-width: 220px;
`

export const DatePicker: React.FC<{
  date?: string // ISO string
  onChange: (dateString: string, rawDate: Date | null) => void
  format?: string
  label?: string
  disabled?: boolean
  name?: string
  invalid?: boolean
  errorText?: string
  required?: boolean
  className?: string
  testId?: string
  optional?: boolean
}> = ({
  date: propsDate = '',
  onChange,
  label,
  disabled,
  required,
  errorText,
  invalid,
  name,
  className,
  format,
  testId,
  optional,
}) => {
  const date = parseISO(propsDate)
  const isFirstChange = useRef(true)
  const handleDateChange = useCallback(
    value => {
      // default time is 12:00
      let selectedDateTime = value || ''
      if (value && isFirstChange.current) {
        selectedDateTime = set(new Date(value as Date), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        })
        isFirstChange.current = false
      } else if (value) {
        selectedDateTime = new Date(value as Date)
      }
      onChange(selectedDateTime instanceof Date ? selectedDateTime.toISOString() : '', selectedDateTime || null)
    },
    [onChange],
  )
  let locale = 'en-CA'
  // window is undefined in SSR
  if (typeof window !== 'undefined' && window.navigator?.language) {
    locale = window.navigator.language
  }

  return (
    <Wrapper data-invalid={invalid} data-test-id={testId}>
      <FormField
        name={name}
        className={className}
        label={label}
        invalid={invalid}
        errorText={errorText}
        required={required}
        optional={optional}
        render={() => (
          <DateTimePicker
            dayPlaceholder={'DD'}
            monthPlaceholder={'MM'}
            yearPlaceholder={'YY'}
            value={isValid(date) ? date : null}
            onChange={handleDateChange}
            format={format || 'dd/MM/yy HH:mm'}
            locale={locale}
            calendarIcon={<IconCalendar />}
            disabled={disabled}
            name={'datetime-picker'}
            showLeadingZeros
            disableClock
          />
        )}
      />
    </Wrapper>
  )
}
